import React, { Component } from "react";
import Data from "../config/data";
let _Gitv = window.gitv;
_Gitv && _Gitv.onInit();
export default class HelpPage extends Component {

    componentDidMount(){
        _Gitv && _Gitv.setExitOnNextBack("true");
    }

    render() {
        const data = Data.help;
        return (<div className="help">
            <div className="headTitle">{data.name}</div>
            <div className="preamble"></div>
            {data.mainWords.map((mainWord, i) => {
                return <div key={i}>
                    <div className="title">{mainWord.title}</div>
                    <div className="content">
                        {mainWord.wordlist.map((word, i) =>
                            <div key={i} dangerouslySetInnerHTML={{ __html: word }}></div>
                        )}
                    </div>
                </div>
            })}
        </div>);
    }

}


// WEBPACK FOOTER //
// ./src/component/helppage.js